module.exports = __webpack_public_path__ + "static/img/019.1c2640e3.svg";